import React, { useState } from "react";
import { Table } from "react-bootstrap";
import "../../assets/styles/layers.scss";
import LayersActionButtons from "./LayersActionButtons";

const LayersTable = ({ layersData, onSelectionChange, onEdit, onDelete, onSort, onLayerClick }) => {
  const [selectedLayers, setSelectedLayers] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [sortConfig, setSortConfig] = useState({ key: "Name", direction: "asc" });

  const handleSelectAll = (e) => {
    const isChecked = e.target.checked;
    setSelectAll(isChecked);
    
    if (isChecked) {
      const allIds = layersData.map(layer => layer.id);
      setSelectedLayers(allIds);
      if (onSelectionChange) {
        onSelectionChange(allIds);
      }
    } else {
      setSelectedLayers([]);
      if (onSelectionChange) {
        onSelectionChange([]);
      }
    }
  };

  const handleCheckboxChange = (e, layerId) => {
    e.stopPropagation();
    const isChecked = e.target.checked;
    let newSelection;

    if (isChecked) {
      newSelection = [...selectedLayers, layerId];
    } else {
      newSelection = selectedLayers.filter(id => id !== layerId);
      setSelectAll(false);
    }

    setSelectedLayers(newSelection);
    if (onSelectionChange) {
      onSelectionChange(newSelection);
    }

    // Check if all items are selected
    if (newSelection.length === layersData.length && layersData.length > 0) {
      setSelectAll(true);
    }
  };

  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
    if (onSort) {
      onSort({ key, direction });
    }
  };

  const getSortIcon = (key) => {
    if (sortConfig.key !== key) {
      return " ⇅";
    }
    return sortConfig.direction === "asc" ? " ▲" : " ▼";
  };

  const handleRowClick = (layer) => {
    if (onLayerClick) {
      onLayerClick(layer);
    }
  };

  return (
    <Table responsive striped bordered hover size="sm" className="layers-table">   
        <thead>
            <tr>
              <th style={{ width: '50px', textAlign: 'center', height: '56px', verticalAlign: 'middle' }}>
                <input 
                  type="checkbox"
                  checked={selectAll}
                  onChange={handleSelectAll}
                />
              </th>
              <th style={{ width: '100px', textAlign: 'center', height: '56px', verticalAlign: 'middle' }}>Akcje</th>
              <th 
                style={{ height: '56px', verticalAlign: 'middle', cursor: 'pointer', userSelect: 'none' }}
                onClick={() => handleSort('Name')}
              >
                Nazwa warstwy{getSortIcon('Name')}
              </th>
            </tr>
        </thead>
        <tbody>
            {layersData && layersData.length > 0 ? (
              layersData.map((layer) => (
                <tr key={layer.id}>
                    <td onClick={(e) => e.stopPropagation()} style={{ textAlign: 'center' }}>
                      <input 
                        type="checkbox"
                        checked={selectedLayers.includes(layer.id)}
                        onChange={(e) => handleCheckboxChange(e, layer.id)}
                      />
                    </td>
                    <td onClick={(e) => e.stopPropagation()}>
                      <LayersActionButtons 
                        layerId={layer.id}
                        onEdit={onEdit}
                        onDelete={onDelete}
                      />
                    </td>
                    <td 
                      onClick={() => handleRowClick(layer)}
                      style={{ cursor: 'pointer' }}
                    >
                      {layer.name}
                    </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="3" className="text-center">Brak warstw do wyświetlenia</td>
              </tr>
            )}
        </tbody>
    </Table>
  );
};

export default LayersTable;